import dayjs from 'dayjs'

import { fromNowToFullDate } from 'lib/time'

import './style.scss'

const PostTime = ({ createdAt }) => {
  return (
    <time className="PostTime" title={dayjs(createdAt * 1000).format()}>
      {fromNowToFullDate(createdAt * 1000)}
    </time>
  )
}

export default PostTime
